import Schema from './schema';

const VERSION = 1;

export default Object.freeze({
    version: VERSION,
    description: 'Initial version',
    mappingsChanges: Schema(VERSION),
});
